// Huella del token de usuario conocido (?token=) para saber si ya se aplico en esta pestaña sin
// guardar el token en sessionStorage (T-2026-196). Es SHA-256 del token tal cual: a diferencia de
// utils/sha256 no se pasa a minusculas, porque el token distingue mayusculas.
const huellaToken = async (token) => {
  if (!token) return null;
  const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(String(token)));
  return Array.from(new Uint8Array(buf))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
};

export default huellaToken;
